export const AREAS_OPTIONS = [
  "Audición",
  "Vestibular",
  "Comunicación y lenguaje",
  "Habla",
  "Neurorehabilitación",
  "Voz",
  "Motricidad orofacial",
];

export const POBLACION_OPTIONS = [
  "Recién nacidos",
  "Niños/as",
  "Adolescentes",
  "Adultos",
  "Adultos mayores",
];

export const REDES_CONFIG = [
  {
    key: "facebook",
    label: "Facebook",
    placeholder: "https://facebook.com/tu-perfil",
  },
  {
    key: "instagram",
    label: "Instagram",
    placeholder: "https://instagram.com/tu-perfil",
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    placeholder: "https://linkedin.com/in/tu-perfil",
  },
  {
    key: "x.com",
    label: "X (Twitter)",
    placeholder: "https://x.com/tu-usuario",
  },
] as const;

export type RedKey = (typeof REDES_CONFIG)[number]["key"];

export function getRedUrl(redes: string[], key: RedKey): string {
  return redes.find((u) => u.toLowerCase().includes(key)) ?? "";
}

export function buildRedes(redUrls: Record<RedKey, string>): string[] {
  return Object.values(redUrls).filter((u) => u.trim() !== "");
}

// Máscara de CUIT: 99-99999999-9
export function formatCuit(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  const parts = [digits.slice(0, 2), digits.slice(2, 10), digits.slice(10)];
  return parts.filter(Boolean).join("-");
}
